var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.834 1.7c.687 0 1.25-.001 1.707.036.466.038.892.12 1.291.324a3.3 3.3 0 0 1 1.442 1.442c.203.399.285.825.323 1.291.037.457.037 1.02.037 1.707v11a.8.8 0 0 1-1.197.694L10 15.088l-5.437 3.106a.8.8 0 0 1-1.196-.694v-11c0-.687-.001-1.25.036-1.707.038-.466.12-.892.324-1.291A3.3 3.3 0 0 1 5.169 2.06c.399-.204.825-.286 1.291-.324C6.917 1.7 7.48 1.7 8.167 1.7z"
})));
SvgBookmarkFilled.displayName = "SvgBookmarkFilled";
export { SvgBookmarkFilled as ReactComponent };
export default SvgBookmarkFilled;